import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { Button } from "~/features/ui/button";
import { takeFirst } from "~/features/app/utils";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
const fragment = graphql(`
  fragment FooterAdditionalLink on footerAdditionalLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function FooterAdditionalLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  const icon = useLinkIcon(link || undefined);
  if (!isLinkValid(link)) {
    return null;
  }
  return <Button variant="underline" as={Link} {...link} icon={icon} />;
}